import "./NutritionistProfile.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import loginService from "../../services/login-service";
import Avatar from "../../components/Avatar/Avatar";
import nutritionistService from "../../services/nutritionist-service";
import { GlobalContext } from "../GlobalContext";

import PinkShieldIcon from "../../assets/imgs/pink-shield-icon.svg";
import RoundStarIcon from "../../assets/imgs/round-star-icon.svg";
import PinkTooltipIcon from "../../assets/imgs/pink-tooltip-icon.svg";
import CloseIconGray from "../../assets/imgs/close-icon-gray.svg";
import DefaultButton from "../../components/DefaultButton/DefaultButton";
import AvatarSelector from "../../components/AvatarSelector/AvatarSelector";
import NotificationBar from "../../components/NotificationBar/NotificationBar";
import AddressModal from "../../components/AddressModal/AddressModal";

const SuggestionSection = ({ show, condition, title, description, onAccept, onRefuse }) => {
  const [showSuggestion, setShowSuggestion] = useState(show);

  useEffect(() => {
    setShowSuggestion(show);
  }, [show]);

  return (
    <>
      {showSuggestion && condition && (
        <div className="nutritionist-profile__suggestion">
          <p className="nutritionist-profile__suggestion__title">{title}</p>
          <p className="nutritionist-profile__suggestion__description">{description}</p>
          <div className="nutritionist-profile__suggestion__actions">
            <DefaultButton
              title="Agora não"
              type="secondary"
              onClick={onRefuse}
              size="small"
              style="nutritionist-profile__suggestion__actions__button"
            />
            <DefaultButton
              title="Escolher avatar"
              type="primary"
              onClick={onAccept}
              size="small"
            />
          </div>
        </div>
      )}
    </>
  )
}

const NutritionistProfile = () => {
  const [nutritionist, setNutritionist] = useState();
  const [showAvatarSelectorModal, setShowAvatarSelectorModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showAddPhotoSuggestion, setShowAddPhotoSuggestion] = useState(true);
  const [showAddAddressSuggestion, setShowAddAddressSuggestion] = useState(true);
  const [notificationBar, setNotificationBar] = useState();
  const { setIsLoading } = useContext(GlobalContext);

  const fetchNutritionist = useCallback(async () => {
    setIsLoading(true);
    const userFromStorage = await loginService.getCurrentUser();
    const user = await nutritionistService.getNutritionistById(userFromStorage?.id);
    setNutritionist(user);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    Promise.resolve(fetchNutritionist());
  }, []);

  const EditableField = ({ label, value, description, disabled }) => {
    const [openTooltip, setOpenTooltip] = useState(false);
    const [contentHeight, setContentHeight] = useState(0);
    const [showEdit, setShowEdit] = useState(false);
    const [inputValue, setInputValue] = useState(value);
    const inputRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
      if (contentRef.current) {
        setContentHeight(contentRef.current.clientHeight);
      }
    }, [contentRef?.current?.clientHeight]);

    useEffect(() => {
      if (contentRef.current) {
        setContentHeight(contentRef.current.clientHeight);
      }
    }, [openTooltip]);

    useEffect(() => {
      if (showEdit) {
        inputRef.current.focus();
      }
    }, [showEdit]);

    return (
      <>
        <div
          className="editable-field"
          onMouseLeave={() => setTimeout(() => {
            setOpenTooltip(false)
          }, 100)}
        >
          <div className="editable-field__info">
            <div className="editable-field__label">
              {label}
              {description && (
                <div href="javascript:;" className="editable-field__tooltip">
                  <a
                    href="javascript:;"
                    className="editable-field__tooltip__icon"
                    onMouseEnter={() => setOpenTooltip(true)}
                  >
                    <img src={PinkTooltipIcon} alt="Tooltip icon" />
                  </a>
                  {openTooltip && (
                    <div
                      className="editable-field__tooltip__content" ref={contentRef}
                      style={{ marginTop: `-${contentHeight + 30}px` }}
                    >
                      <p>{description}</p>
                      <a
                        href="javascript:;"
                        className="editable-field__tooltip__close"
                        onClick={() => setOpenTooltip(false)}
                      >
                        <img src={CloseIconGray} alt="Close icon" />
                      </a>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="editable-field__value">
              <input
                ref={inputRef}
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                disabled={!showEdit}
              />
            </div>
          </div>
          {!disabled && (
            <div className="editable-field__edit">
              <a
                href="javascript:;"
                onClick={() => setShowEdit(show => !show)}
              >{showEdit ? "Salvar" : "Editar"}</a>
            </div>
          )}
        </div>
      </>
    )
  };

  const SpecializationsField = ({
    nutritionistId,
    specializations,
    currentSpecializations,
    onSuccess,
    onError,
  }) => {
    const [showEdit, setShowEdit] = useState(false);
    const [selectedSpecializations, setSelectedSpecializations] = useState(new Map());
    const { setIsLoading } = useContext(GlobalContext);

    const handleSelectSpecialization = (specialization) => {
      if (selectedSpecializations.get(specialization.id)) {
        setSelectedSpecializations((prev) => {
          const newMap = new Map(prev);
          newMap.delete(specialization.id);
          return newMap;
        });
        return;
      }
      
      setSelectedSpecializations((prev) => {
        const newMap = new Map(prev);
        newMap.set(specialization.id, specialization);
        return newMap;
      });
    }

    const handleUpdateSpecializations = async () => {
      const specializationIds = Array.from(selectedSpecializations.keys());
      setIsLoading(true);

      console.log(specializationIds);

      try {
        const nutritionist = await nutritionistService.updateNutritionist(nutritionistId, {
          specialization_ids: specializationIds,
        });
        onSuccess(nutritionist);
        setShowEdit(false);
      } catch (ex) {
        onError(ex);
      } finally {
        setIsLoading(false);
      }
    }

    useEffect(() => {
      setSelectedSpecializations(new Map());
      currentSpecializations.forEach((specialization) => {
        setSelectedSpecializations((prev) => {
          const newMap = new Map(prev);
          newMap.set(specialization.id, specialization);
          return newMap;
        });
      });
    }, [currentSpecializations, showEdit]);

    return (
      <>
        <div className="editable-field">
          <div className="editable-field__info">
            <div className="editable-field__label">Especialidades</div>
            {!showEdit && (
              <div className="editable-field__value">
                <p>{formatSpecializations(currentSpecializations)}</p>
              </div>
            )}
            {showEdit && (
              <div className="editable-specializations">
                {specializations.map((specialization) => (
                  <a
                    className={`editable-specializations__item ${selectedSpecializations.get(specialization.id) ? "editable-specializations__item--selected" : ""}`}
                    onClick={() => handleSelectSpecialization(specialization)}
                    href="javascript:;"
                  >
                    {specialization.name}
                  </a>
                ))}
              </div>
            )}
          </div>
          {(
            <div className="editable-field__edit">
              <a
                href="javascript:;"
                onClick={() => {
                  if (showEdit) {
                    handleUpdateSpecializations();
                  } else {
                    setShowEdit(true);
                  }
                }}
              >{showEdit ? "Salvar" : "Editar"}</a>
            </div>
          )}
        </div>
      </>
    )
  };

  const AddableField = ({ label, value, defaultValue }) => {
    const [inputValue, setInputValue] = useState(value);
    const [showEdit, setShowEdit] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
      if (showEdit) {
        inputRef.current.focus();
      }
    }, [showEdit]);

    useEffect(() => {
      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }, [inputValue]);

    return (
      <div className="addable-field">
        <div className="addable-field__info">
          <p className="addable-field__label">{label}</p>
          <div className="addable-field__value">
            <textarea
              ref={inputRef}
              value={inputValue}
              placeholder={defaultValue}
              onChange={(e) => setInputValue(e.target.value)}
              onBlur={() => {
                setShowEdit(false);
              }}
              disabled={!inputValue && !showEdit}
            />
          </div>
        </div>
        {!inputValue && !showEdit && (
          <div className="addable-field__action">
            <a
              href="javascript:;"
              onClick={() => setShowEdit(show => !show)}
            >
              Adicionar
            </a>
          </div>
        )}
      </div>
    )
  }

  const getFormattedAddress = (address) => {
    if (!address) {
      return 'Sem endereço';
    }
    const identification = `${address.street}, ${address.number}, ${address.complement ? `${address.complement}` : ''}`;
    return `${identification}. ${address.neighborhood}, ${address.city} - ${address.state}, ${address.zip_code}.`;
  }

  const AddressField = ({ address, onClick }) => {
    return (
      <div className="addable-field">
        <div className="addable-field__info">
          <p className="addable-field__label">Endereço</p>
          <a className="addable-field__value" onClick={() => onClick()} href="javascript:;">
            <p>{getFormattedAddress(address)}</p>
          </a>
        </div>
        {!address && (
          <div className="addable-field__action">
            <a
              href="javascript:;"
              onClick={() => onClick()}
            >
              Adicionar
            </a>
          </div>
        )}
      </div>
    )
  }

  const formatDate = (date) => {
    if (!date) {
      return "";
    }

    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  const genderOptions = {
    MALE: "Masculino",
    FEMALE: "Feminino",
  }

  const formatSpecializations = (specializations) => {
    if (!specializations || specializations.length === 0) {
      return "Sem especialidades";
    }

    return specializations.map((specialization) => specialization.name).join(", ");
  }

  const specializations = [
    {
      "id": 1,
      "name": "Nutrição Clínica",
      "description": "Atuação na prevenção, diagnóstico e tratamento de doenças por meio de orientações alimentares e dietas individualizadas."
    },
    {
      "id": 2,
      "name": "Nutrição Esportiva",
      "description": "Focada na performance física, suplementação adequada e melhoria do desempenho de atletas e praticantes de atividades físicas."
    },
    {
      "id": 3,
      "name": "Nutrição Materno-Infantil",
      "description": "Acompanhamento nutricional de gestantes, lactantes e crianças, visando o desenvolvimento saudável."
    },
    {
      "id": 4,
      "name": "Nutrição Funcional",
      "description": "Enfoque na relação entre alimentos, nutrientes e metabolismo, considerando a individualidade bioquímica para equilibrar o organismo."
    },
    {
      "id": 5,
      "name": "Nutrição Oncológica",
      "description": "Orientações nutricionais específicas para pacientes em tratamento contra o câncer, visando manutenção do estado nutricional."
    },
    {
      "id": 6,
      "name": "Nutrição em Saúde Pública",
      "description": "Elaboração e implementação de políticas e programas de alimentação para a população em geral."
    },
    {
      "id": 7,
      "name": "Nutrição Estética",
      "description": "Direcionada à melhora da aparência, saúde da pele, cabelos e unhas, por meio de dieta equilibrada e suplementação."
    },
    {
      "id": 8,
      "name": "Fitoterapia Aplicada à Nutrição",
      "description": "Utilização de plantas medicinais e fitoterápicos na prescrição nutricional para complementar o tratamento de diversas condições."
    },
    {
      "id": 9,
      "name": "Nutrição Hospitalar",
      "description": "Atuação em hospitais, elaborando e supervisionando dietas específicas para pacientes internados."
    },
    {
      "id": 10,
      "name": "Nutrição Geriátrica",
      "description": "Acompanhamento de idosos, considerando as alterações fisiológicas da idade e o risco de desnutrição ou doenças crônicas."
    }
  ]

  return (
    <>
      <div className="nutritionist-profile">
        <Breadcrumb
          previousPage={{ href: "/profile", title: "Meu perfil" }}
          currentPage={{ title: "Informações pessoais" }}
        />
        <div className="nutritionist-profile__title">
          <h1>Informações pessoais</h1>
        </div>
        {nutritionist && (
          <div className="nutritionist-profile__content">
            <div className="nutritionist-profile__personal-info">
              <EditableField label="Nome completo" value={nutritionist?.name} disabled />
              <EditableField label="E-mail" value={nutritionist?.email} disabled />
              <EditableField label="Data de nascimento" value={formatDate(nutritionist?.birth_date)} disabled />
              <EditableField label="Gênero" value={genderOptions[nutritionist?.gender]} disabled />
              <EditableField
                label="Inscrição"
                value={nutritionist?.professional_document?.registration_number}
                description="Número de registro no Conselho Regional de Nutricionistas"
                disabled
              />
              <EditableField
                label="CRN"
                value={`CRN-${nutritionist?.professional_document?.crn}`}
                description="Conselho Regional de Nutricionistas"
                disabled
              />
              <SpecializationsField
                nutritionistId={nutritionist?.id}
                specializations={specializations}
                currentSpecializations={nutritionist?.specializations || []}
                onSuccess={(updatedNutritionist) => {
                  setNotificationBar({
                    title: "Especialidades atualizadas com sucesso!",
                    type: "success",
                  });
                  setNutritionist(updatedNutritionist);
                }}
                onError={() => {
                  setNotificationBar({
                    title: "Erro ao atualizar especialidades.",
                    type: "error",
                  });
                }}
              />
              <div className="nutritionist-profile__personal-info__warning">
                <div className="nutritionist-profile__personal-info__warning__icon">
                  <img src={PinkShieldIcon} alt="Shield icon" />
                </div>
                <p>Os pacientes só podem ver o nome e a especialidade do nutricionista. Outras informações são restritas por motivos de privacidade.</p>
              </div>
            </div>
            <div className="nutritionist-profile__preview">
              <div className="nutritionist-profile__preview__title">
                <h2>Como os pacientes veem você</h2>
              </div>
              <div className="nutritionist-profile__preview__content">
                <div className="nutritionist-profile__preview__content__avatar">
                  <Avatar
                    user={nutritionist}
                    verified={true}
                    onClick={() => setShowAvatarSelectorModal(true)}
                  />
                  <div className="nutritionist-profile__preview__content__avatar__edit">
                    <a
                      href="javascript:;"
                      onClick={() => setShowAvatarSelectorModal(true)}
                    >Trocar avatar</a>
                  </div>
                </div>
                <div className="nutritionist-profile__preview__content__name">
                  <p>{nutritionist?.name}</p>
                </div>
                <div className="nutritionist-profile__preview__content__specializations">
                  <p>{formatSpecializations(nutritionist?.specializations)}</p>
                </div>
                <div className="nutritionist-profile__preview__content__metrics">
                  <div className="nutritionist-profile__preview__content__metric">
                    <p className="nutritionist-profile__preview__content__value">11</p>
                    <p className="nutritionist-profile__preview__content__label">Comentários</p>
                  </div>
                  <div className="nutritionist-profile__preview__content__metric">
                    <div className="nutritionist-profile__preview__content__value">
                      {nutritionist.average_rating}
                      <img src={RoundStarIcon} alt="Star icon" />
                    </div>
                    <p className="nutritionist-profile__preview__content__label">Avaliações</p>
                  </div>
                  <div className="nutritionist-profile__preview__content__metric">
                    <p className="nutritionist-profile__preview__content__value">10</p>
                    <p className="nutritionist-profile__preview__content__label">Meses ativo</p>
                  </div>
                </div>
                <div className="nutritionist-profile__preview__content__addables">
                  <AddableField label="Descrição" value={nutritionist?.about} defaultValue="Sem descrição" />
                  <AddressField
                    address={nutritionist?.address}
                    onClick={() => {
                      setShowAddressModal(true);
                    }}
                  />
                </div>
              </div>
              {showAddPhotoSuggestion && !nutritionist?.photo_url && (
                <div className="nutritionist-profile__suggestion">
                  <p className="nutritionist-profile__suggestion__title">Que tal adicionar um avatar ao seu perfil?</p>
                  <p className="nutritionist-profile__suggestion__description">Isso ajuda a tornar sua presença mais personalizada e amigável para seus pacientes</p>
                  <div className="nutritionist-profile__suggestion__actions">
                    <DefaultButton
                      title="Agora não"
                      type="secondary"
                      onClick={() => setShowAddPhotoSuggestion(false)}
                      size="small"
                      style="nutritionist-profile__suggestion__actions__button"
                    />
                    <DefaultButton
                      title="Escolher avatar"
                      type="primary"
                      onClick={() => setShowAvatarSelectorModal(true)}
                      size="small"
                    />
                  </div>
                </div>
              )}
              <SuggestionSection
                show={showAddAddressSuggestion}
                condition={!nutritionist?.address}
                title="Que tal adicionar um endereço ao seu perfil?"
                description="Essa informação é necessária para que os pacientes agendem consultas com você."
                onAccept={() => {
                  setShowAddressModal(true);
                }}
                onRefuse={() => setShowAddAddressSuggestion(false)}
              />
            </div>
          </div>
        )}
      </div>
      <AddressModal
        nutritionistId={nutritionist?.id}
        address={nutritionist?.address}
        showModal={showAddressModal}
        onClose={() => setShowAddressModal(false)}
        onSuccess={(updatedNutritionist) => {
          setNotificationBar({
            title: "Endereço atualizado com sucesso!",
            type: "success",
          });
          setNutritionist(updatedNutritionist);

        }}
        onError={() => {
          setNotificationBar({
            title: "Erro ao atualizar endereço.",
            type: "error",
          })
        }}
      />
      <AvatarSelector
        user={nutritionist}
        show={showAvatarSelectorModal}
        onClose={() => {
          setShowAvatarSelectorModal(false);
          fetchNutritionist();
        }}
        setNotificationBar={setNotificationBar}
      />
      <NotificationBar
        show={notificationBar?.title}
        title={notificationBar?.title}
        durationInSeconds={4}
        onClose={() => setNotificationBar(null)}
      />
    </>
  );
};

export default NutritionistProfile;

NutritionistProfile.propTypes = {};
